<script>
import { Modal } from "@intasect/ant-design-vue";
import { defineComponent, h, nextTick } from "vue";
import IButton from "../IButton/IButton";
import IIcon from "../IIcon/IIcon.vue";

export default defineComponent({
    name: "i-modal",
    components: {
        Modal,
        IButton,
    },
    emit: ["ok", "cancel", "afterClose"],
    watch: {
        visible: {
            handler(val) {
                if (
                    val &&
                    this.$props.isfullScreen &&
                    this.fullScreen === false
                ) {
                    nextTick(() => {
                        this.troggleFullScreen();
                    });
                } else if (!val) {
                    this.fullScreen = false;
                }
                val && nextTick(this.moveToCenter);
            },
            immediate: true,
        },
        disableMove: function (val) {
            this.moveAction(!val);
        },
    },
    data(context) {
        return {
            realWidth: parseInt(this.$props.width) || this.initWidth(),
            minHeight: 300,
            minWidth: 900,
            maxHeight: 0,
            maxWidth: 0,
            realHeight: this.$props.height || 0,
            top: 0,
            left: 0,
            direction: "none",
            mouseX: 0,
            mouseY: 0,
            resize: false,
            move: false,
            screenWidth: 0,
            screenHeight: 0,
            fullScreen: false,
            firstShow: true,
        };
    },
    props: {
        //是否开启可调宽高度
        disableResize: Boolean,
        //是否开启可移动
        disableMove: Boolean,
        //是否隐藏全屏按钮
        hideFullScreen: Boolean,
        //是否可见
        visible: Boolean,
        //标题
        title: String,
        //是否全屏显示
        isfullScreen: Boolean,
        //是否显示取消按钮
        showCancel: {
            type: Boolean,
            default: true,
        },
        //是否显示确定按钮
        showOk: {
            type: Boolean,
            default: true,
        },
        //确定按钮的内容
        okText: {
            type: [String, Function],
            default: () => "确定",
        },
        //取消按钮的内容
        cancelText: {
            type: [String, Function],
            default: () => "取消",
        },
        size: String,
        width: { type: [Number, String] },
        height: { type: [Number, String] },
        // ShowWidth:Number
        // 垂直居中默认
        // centered:{
        //     type:Boolean,
        //     default:true
        // }
    },
    mounted() {
        window.addEventListener("mousemove", this.onResize);
        window.addEventListener("mousemove", this.onMove);
        window.addEventListener("mouseup", this.endResize);
        window.addEventListener("mouseup", this.endMove);
        window.addEventListener("resize", this.moveToCenter);
        setTimeout(this.moveToCenter, 0);
        setTimeout(() => {
            this.moveAction(!this.disableMove);
        }, 0);
        this.modalRefVal = null;
    },
    beforeUnmount() {
        window.removeEventListener("mousemove", this.onResize);
        window.removeEventListener("mousemove", this.onMove);
        window.removeEventListener("mouseup", this.endResize);
        window.removeEventListener("mouseup", this.endMove);
        window.removeEventListener("resize", this.moveToCenter);
        this.moveAction(false);
        clearInterval(this.interVal);
    },
    methods: {
        getModalRef() {
            if (!this.modalRefVal && this.$refs.modalRef) {
                this.modalRefVal =
                    this.$refs.modalRef.parentNode.parentNode.parentNode.parentNode.parentNode;
            }
            return this.modalRefVal;
        },
        setModalPostion(position) {
            const { top = 0, left = 0, width = 0, height = 0 } = position;
            this.top =
                top ||
                parseInt(
                    this.getModalRef().querySelector(".ant-modal").style.top ||
                        10
                );
            this.left =
                left ||
                parseInt(
                    this.getModalRef().querySelector(".ant-modal").style.left ||
                        10
                );
            this.realHeight =
                height ||
                parseInt(
                    this.getModalRef().querySelector(".ant-modal-body")
                        .offsetHeight
                );
            this.realWidth =
                width ||
                parseInt(
                    this.getModalRef().querySelector(".ant-modal").offsetWidth
                );
            this.getModalRef().querySelector(".ant-modal").style.top =
                this.top + "px";
            this.getModalRef().querySelector(".ant-modal").style.left =
                this.left + "px";
            this.getModalRef().querySelector(".ant-modal-body").style.height =
                this.realHeight + "px";
            this.getModalRef().querySelector(".ant-modal").style.width =
                this.realWidth + "px";
        },
        getModalPostion() {
            this.top = parseInt(
                this.getModalRef().querySelector(".ant-modal").style.top || 10
            );
            this.left = parseInt(
                this.getModalRef().querySelector(".ant-modal").style.left || 10
            );
            this.realHeight = parseInt(
                this.getModalRef().querySelector(".ant-modal-body").offsetHeight
            );
            this.realWidth = parseInt(
                this.getModalRef().querySelector(".ant-modal").offsetWidth
            );
            this.modalHeight = parseInt(
                this.getModalRef().querySelector(".ant-modal").offsetHeight
            );
        },
        handleResize(direction, e) {
            this.direction = direction;
            this.beginResize(e, direction);
        },
        getMouseEvenInfo(e) {
            this.mouseX = e.x;
            this.mouseY = e.y;
        },
        beginResize(e, direction) {
            if (!this.fullScreen) {
                this.resize = true;
                this.getMouseEvenInfo(e);
                this.getModalPostion();
                if (direction.indexOf("up") > -1) {
                    this.getModalRef().querySelector(
                        ".ant-modal-body"
                    ).style.maxHeight = "100vh";
                } else {
                    this.computeMaxHeight();
                }
                if (direction.indexOf("left") > -1) {
                    this.getModalRef().querySelector(
                        ".ant-modal"
                    ).style.maxWidth = "100%";
                } else {
                    this.computeMaxWidth();
                }
            }
        },
        onResize(e) {
            if (this.resize) {
                switch (this.direction) {
                    case "left":
                        this.handleWidth(e, true);
                        break;
                    case "right":
                        this.handleWidth(e);
                        break;
                    case "up":
                        this.handleHeight(e, true);
                        break;
                    case "down":
                        this.handleHeight(e);
                        break;
                    case "up-left":
                        this.handleWidth(e, true);
                        this.handleHeight(e, true);
                        break;
                    case "up-right":
                        this.handleWidth(e);
                        this.handleHeight(e, true);
                        break;
                    case "down-left":
                        this.handleWidth(e, true);
                        this.handleHeight(e);
                        break;
                    case "down-right":
                        this.handleWidth(e);
                        this.handleHeight(e);
                        break;
                }
                this.$emit("resize");
            }
        },
        handleHeight(e, withPosition) {
            let val = withPosition ? this.mouseY - e.y : e.y - this.mouseY;
            let h = this.realHeight + val;
            if (h < this.minHeight) {
                h = this.minHeight;
                val = h - this.realHeight;
            }
            let t = this.top - val;
            if (withPosition) {
                if (t < 10) {
                    t = 10;
                    h = this.realHeight + this.top - t;
                }
                this.getModalRef().querySelector(
                    ".ant-modal"
                ).style.top = `${t}px`;
            }
            const bodyNode =
                this.getModalRef().querySelector(".ant-modal-body");
            bodyNode.style.height = `${h}px`;
            if (bodyNode.offsetHeight < h) {
                bodyNode.style.height = `${bodyNode.offsetHeight}px`;
            }
        },
        handleWidth(e, withPosition) {
            let val = withPosition ? this.mouseX - e.x : e.x - this.mouseX;
            let w = this.realWidth + val;
            if (w < this.minWidth) {
                w = this.minWidth;
                val = w - this.realWidth;
            }
            let l = this.left - val;
            const modalNode = this.getModalRef().querySelector(".ant-modal");
            if (withPosition) {
                if (l < 10) {
                    l = 10;
                    w = this.realWidth + this.left - l;
                }
                modalNode.style.left = `${l}px`;
            }
            modalNode.style.width = `${w}px`;

            if (modalNode.offsetWidth < w) {
                modalNode.style.width = `${modalNode.offsetWidth}px`;
            }
        },
        endResize() {
            if (this.resize) {
                this.direction = "none";
                this.resize = false;
                this.getModalPostion();
                this.computeMaxHeight();
                this.computeMaxWidth();
            }
        },
        renderDefaultFoot() {
            const result = [];
            if (this.$props.showCancel) {
                result.push(
                    h(
                        IButton,
                        {
                            type: "default",
                            onclick: this.buttonCancel,
                        },
                        {
                            default: () => {
                                if (
                                    typeof this.$props.cancelText === "string"
                                ) {
                                    return this.$props.cancelText;
                                } else if (
                                    typeof this.$props.cancelText === "function"
                                ) {
                                    return this.$props.cancelText(
                                        this.buttonCancel
                                    );
                                }
                                return "取消";
                            },
                        }
                    )
                );
            }
            if (this.$props.showOk) {
                result.push(
                    h(
                        IButton,
                        {
                            type: "primary",
                            onclick: this.buttonOk,
                        },
                        {
                            default: () => {
                                if (typeof this.$props.okText === "string") {
                                    return this.$props.okText;
                                } else if (
                                    typeof this.$props.okText === "function"
                                ) {
                                    return this.$props.okText(this.buttonOk);
                                }
                                return "确定";
                            },
                        }
                    )
                );
            }
            return result;
        },
        buttonOk() {
            this.$attrs.onOk && this.$attrs.onOk();
        },
        buttonCancel() {
            this.$attrs.onCancel && this.$attrs.onCancel();
        },
        renderResizeBar(direction, title) {
            return h("div", {
                key: `__r${direction}`,
                class: `resizebar ${direction}${
                    this.fullScreen ? " fullscreen" : ""
                }`,
                title: `调整${title}度`,
                onMousedown: e => {
                    this.handleResize(direction, e);
                },
            });
        },
        renderResizeBars() {
            if (!this.disableResize) {
                return [
                    this.renderResizeBar("up", "高"),
                    this.renderResizeBar("down", "高"),
                    this.renderResizeBar("right", "宽"),
                    this.renderResizeBar("left", "宽"),
                    this.renderResizeBar("up-left", "宽高"),
                    this.renderResizeBar("up-right", "宽高"),
                    this.renderResizeBar("down-left", "宽高"),
                    this.renderResizeBar("down-right", "宽高"),
                ];
            } else {
                return [];
            }
        },
        moveToCenter() {
            if (
                !this.fullScreen &&
                this.getModalRef() &&
                this.$props.visible &&
                !this.$props.disableResize
            ) {
                this.getModalPostion();
                this.computeMaxHeight();
                this.computeMaxWidth();
                const maskNode = this.getModalRef().querySelector(".i-modal");
                const maskWidth = maskNode.offsetWidth;
                const maskHeight = maskNode.offsetHeight;
                const modalNode = maskNode.children[0];
                const modalWidth = modalNode.offsetWidth;
                const modalHeight = Math.max(
                    this.height,
                    modalNode.offsetHeight
                );
                modalNode.style.left = `${(maskWidth - modalWidth) / 2}px`;
                modalNode.style.top = `${(maskHeight - modalHeight) / 2}px`;
            } else if (  this.$props.visible &&this.getModalRef() &&this.$props.disableResize) {
                let maskNode = this.getModalRef().querySelector(".i-modal");
                let maskWidth = maskNode.offsetWidth;
                let maskHeight = maskNode.offsetHeight;
                let modalNode = maskNode.children[0];
                let modalWidth = modalNode.offsetWidth;
                let modalHeight = Math.max(this.height, modalNode.offsetHeight);
                modalNode.style.left = `${(maskWidth - modalWidth) / 2}px`;
                modalNode.style.top = `${(maskHeight - modalHeight) / 2}px`;
            }
        },
        computeMaxHeight() {
            const footerNode =
                this.getModalRef().querySelector(".ant-modal-footer");
            const headerNode =
                this.getModalRef().querySelector(".ant-modal-header");
            this.getModalRef().querySelector(
                ".ant-modal-body"
            ).style.maxHeight = `calc(100vh - ${this.top}px
      - ${headerNode ? headerNode.offsetHeight : 0}px
      - ${footerNode ? footerNode.offsetHeight : 0}px
      - 10px)`;
            this.getModalRef().querySelector(".ant-modal-body").style.height =
                (this.height ?? this.realHeight) + "px";
        },
        computeMaxWidth() {
            this.getModalRef().querySelector(
                ".ant-modal"
            ).style.maxWidth = `calc(100% - ${this.left}px - 10px)`;
        },
        beginMove(e) {
            if (!this.fullScreen) {
                this.move = true;
                this.getMouseEvenInfo(e);
                this.getModalPostion();
                const maskNode = this.getModalRef().children[0];
                this.screenWidth = maskNode.clientWidth;
                this.screenHeight = maskNode.clientHeight;
            }
        },
        onMove(e) {
            if (this.move) {
                const modalNode =
                    this.getModalRef().querySelector(".ant-modal");
                let left = this.left - this.mouseX + e.x;
                let top = this.top - this.mouseY + e.y;
                if (left < 10) {
                    left = 10;
                } else if (left + this.realWidth > this.screenWidth - 10) {
                    left = this.screenWidth - 10 - this.realWidth;
                }
                if (top < 10) {
                    top = 10;
                } else if (top + this.modalHeight > this.screenHeight - 10) {
                    top = this.screenHeight - 10 - this.modalHeight;
                }
                modalNode.style.left = `${left}px`;
                modalNode.style.top = `${top}px`;
            }
        },
        endMove() {
            if (this.move) {
                this.move = false;
            }
        },
        troggleFullScreen() {
            this.fullScreen = !this.fullScreen;
            const el = this.getModalRef();
            const modalNode = el.querySelector(".ant-modal");
            const bodyNode = el.querySelector(".ant-modal-body");
            const footerNode = el.querySelector(".ant-modal-footer");
            const headerNode = el.querySelector(".ant-modal-header");
            if (this.fullScreen) {
                this.getModalPostion();
                modalNode.classList.add("fullScreen");
                var w =
                    document.documentElement.scrollWidth ||
                    document.body.scrollWidth;
                var h =
                    document.documentElement.scrollHeight ||
                    document.body.scrollHeight;
                // modalNode.style.width = w;
                // modalNode.style.maxWidth = h;
                bodyNode.style.height = `${this.realHeight}px`;
                const height = `calc(100vh
        - ${headerNode ? headerNode.offsetHeight : 0}px
        - ${footerNode ? footerNode.offsetHeight : 0}px)`;
                bodyNode.style.height = height;
                bodyNode.style.maxHeight = height;
                headerNode.classList.add("fullscreen");
                if (footerNode) {
                    footerNode.classList.add("fullscreen");
                }
            } else {
                modalNode.classList.remove("fullScreen");
                bodyNode.style.height = `${this.realHeight}px`;
                this.computeMaxWidth();
                this.computeMaxHeight();
                headerNode.classList.remove("fullscreen");
                if (footerNode) {
                    footerNode.classList.remove("fullscreen");
                }
                this.moveToCenter();
            }
        },
        renderFullScreenButton() {
            if (!this.hideFullScreen) {
                return h(
                    "div",
                    {
                        class: "i-modal-fullscreen",
                        title: this.fullScreen ? "还原" : "最大化",
                        onClick: this.troggleFullScreen,
                    },
                    [
                        h(IIcon, {
                            type: this.fullScreen
                                ? "icon-huanyuan"
                                : "icon-a-ziyuan34mdpi",
                        }),
                    ]
                );
            }
        },
        moveAction(bind) {
            const t = this;
            nextTick(() => {
                if (bind) {
                    t.interVal = setInterval(() => {
                        t.moveBind(bind);
                    }, 1000);
                } else {
                    this.moveBind(bind);
                }
            });
        },
        moveBind(bind) {
            if (this.getModalRef()) {
                const titleNode =
                    this.getModalRef().querySelector(".ant-modal-header");
                // const fotterNode =
                //     this.getModalRef().querySelector(".ant-modal-footer");
                if (titleNode) {
                    if (bind) {
                        titleNode.addEventListener("mousedown", this.beginMove);
                        titleNode.classList.add("move");
                    } else {
                        titleNode.removeEventListener(
                            "mousedown",
                            this.beginMove
                        );
                        titleNode.classList.remove("move");
                    }
                }
                // if (fotterNode) {
                //     if (bind) {
                //         fotterNode.addEventListener(
                //             "mousedown",
                //             this.beginMove
                //         );
                //         fotterNode.classList.remove("move");
                //     } else {
                //         fotterNode.removeEventListener(
                //             "mousedown",
                //             this.beginMove
                //         );
                //         fotterNode.classList.remove("move");
                //     }
                // }
                clearInterval(this.interVal);
            }
        },
        initWidth() {
            switch (this.size) {
                case "small":
                    return 560;
                case "middle":
                    return 720;
                case "large":
                    return 960;
                default:
                    return 560;
            }
        },
    },
    render() {
        return h(
            Modal,
            {
                ...this.$attrs,
                visible: this.$props.visible,
                // centered: this.centered,
                wrapClassName: `${this.$attrs.wrapClassName || ""} i-modal`,
                focusTriggerAfterClose: false,
                width: this.realWidth,
                maskClosable: false,
            },
            {
                ...this.$slots,
                footer: () => {
                    const result = this.renderDefaultFoot();
                    if (this.$slots.footer) {
                        return this.$slots.footer(result);
                    } else if (this.$slots.footer === null) {
                        return null;
                    }
                    return result;
                },
                default: () => {
                    const defaultSlot = () => {
                        const result = this.renderResizeBars();
                        if (this.$slots.default) {
                            result.push(...this.$slots.default());
                        }
                        return result;
                    };
                    return h(
                        "div",
                        { ref: "modalRef" },
                        {
                            default: defaultSlot,
                        }
                    );
                },
                title: () => {
                    let titleContent = "";
                    if (this.$props.title) {
                        titleContent = this.$props.title;
                    } else if (this.$slots.title) {
                        titleContent = this.$slots.title();
                    }
                    return [this.renderFullScreenButton(), titleContent];
                },
            }
        );
    },
});
</script>

<style lang="less">
.i-modal {
    .i-modal-fullscreen {
        position: absolute;
        top: 0;
        right: 40px;
        z-index: 10;
        padding: 0;
        color: white;
        font-weight: 700;
        text-decoration: none;
        background: transparent;
        border: 0;
        outline: 0;
        cursor: pointer;
        transition: color 0.3s;
        display: block;
        width: 40px;
        height: 56px;
        font-size: 16px;
        font-style: normal;
        line-height: 56px;
        text-align: center;
        text-transform: none;
        text-rendering: auto;
    }
    .ant-modal-title {
        color: white !important;
    }

    .i-modal-fullscreen:hover {
        color: white;
    }

    .ant-modal-close-x {
        width: 40px;
        color: white !important;
    }

    .ant-modal {
        padding: 0;
        margin: 0;
        overflow: hidden;
        border-radius: 4px;
    }

    .ant-modal.fullScreen {
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
    }

    .ant-modal-header {
        height: 54px;
        background: rgb(28, 118, 231);
        background-image: url("data:image/png;base64,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");
        background-repeat: no-repeat;
    }
    .ant-modal-footer {
        padding: 16px;
    }
    .ant-modal-header.move,
    .ant-modal-footer.move {
        cursor: move;
        user-select: none;

        &.fullscreen {
            cursor: auto;
        }
    }

    .ant-modal-body {
        overflow: auto;
        display: flex;
        flex-direction: column;
        > div {
            height: 100%;
        }
        > .i-table {
            padding: 0;
            margin: 0;
        }
        > .i-query-table {
            display: flex;
            flex-direction: column;
            flex: 1;
            height: 0;
            > .i-table {
                margin: 0;
            }
        }
    }
}

.resizebar {
    user-select: none;
    position: absolute;

    &.fullscreen {
        cursor: auto !important;
    }

    &.up,
    &.down {
        height: 15px;
        cursor: ns-resize;
        left: 15px;
        right: 15px;
    }

    &.up {
        top: -8px;
    }

    &.down {
        bottom: -8px;
    }

    &.left,
    &.right {
        top: 15px;
        bottom: 15px;
        width: 15px;
        cursor: ew-resize;
    }

    &.left {
        left: -8px;
    }

    &.right {
        right: -8px;
    }

    &.up-left,
    &.up-right,
    &.down-left,
    &.down-right {
        width: 20px;
        height: 20px;
    }

    &.up-left,
    &.up-right {
        top: -5px;
    }

    &.down-left,
    &.down-right {
        bottom: -5px;
    }

    &.up-left,
    &.down-left {
        left: -5px;
    }

    &.up-right,
    &.down-right {
        right: -5px;
    }

    &.up-left,
    &.down-right {
        cursor: nw-resize;
    }

    &.up-right,
    &.down-left {
        cursor: ne-resize;
    }
}
</style>
